import React, { useEffect, useState } from "react";
import menu from "./MenuData";
import Icon from "../../components/icon/Icon";
import classNames from "classnames";
import { NavLink, Link } from "react-router-dom";
import { hasAnyPermission, isSuperAdmin } from "../../utils/permissions";
import { api } from "../../utils/api";

const MenuHeading = ({ heading }) => {
  return (
    <li className="nk-menu-heading">
      <h6 className="overline-title text-primary-alt">{heading}</h6>
    </li>
  );
};

const MenuItem = ({ icon, link, text, sub, newTab, child, sidebarToggle, badge, badgeClass, mobileView, ...props }) => {
  let currentUrl;

  const toggleActionSidebar = (e) => {
    if (!sub && !newTab && mobileView) {
      sidebarToggle(e);
    }
  };

  if (window.location.pathname !== undefined) {
    currentUrl = window.location.pathname;
  } else {
    currentUrl = null;
  }

  const menuHeight = (el) => {
    var totalHeight = [];
    for (var i = 0; i < el.length; i++) {
      var margin =
        parseInt(window.getComputedStyle(el[i]).marginTop.slice(0, -2)) +
        parseInt(window.getComputedStyle(el[i]).marginBottom.slice(0, -2));
      var padding =
        parseInt(window.getComputedStyle(el[i]).paddingTop.slice(0, -2)) +
        parseInt(window.getComputedStyle(el[i]).paddingBottom.slice(0, -2));
      var height = el[i].clientHeight + margin + padding;
      totalHeight.push(height);
    }
    totalHeight = totalHeight.reduce((sum, value) => (sum += value));
    return totalHeight;
  };

  const makeParentActive = (el, childHeight) => {
    let element = el.parentElement.parentElement.parentElement;
    let wrap = el.parentElement.parentElement;
    if (element.classList[0] === "nk-menu-item") {
      element.classList.add("active");
      const subMenuHeight = menuHeight(el.parentNode.children);
      wrap.style.height = subMenuHeight + childHeight - 50 + "px";
      makeParentActive(element);
    }
  };

  useEffect(() => {
    var element = document.getElementsByClassName("nk-menu-item active current-page");
    var arrayElement = [...element];

    arrayElement.forEach((dom) => {
      if (dom.parentElement.parentElement.parentElement.classList[0] === "nk-menu-item") {
        dom.parentElement.parentElement.parentElement.classList.add("active");
        const subMenuHeight = menuHeight(dom.parentNode.children);
        dom.parentElement.parentElement.style.height = subMenuHeight + "px";
        makeParentActive(dom.parentElement.parentElement.parentElement, subMenuHeight);
      }
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const menuToggle = (e) => {
    e.preventDefault();
    var self = e.target.closest(".nk-menu-toggle");
    var parent = self.parentElement;
    var subMenu = self.nextSibling;
    var subMenuItem = subMenu.childNodes;
    var parentSiblings = parent.parentElement.childNodes;
    var parentMenu = parent.closest(".nk-menu-wrap");
    //For Sub Menu Height
    var subMenuHeight = menuHeight(subMenuItem);
    // Get parent elements
    const getParents = (el, parentSelector) => {
      parentSelector = document.querySelector("#main-menu");
      if (parentSelector === undefined) {
        parentSelector = document;
      }
      var parents = [];
      var p = el.parentNode;
      while (p !== parentSelector) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
      }
      parents.push(parentSelector);
      return parents;
    };
    var parentMenus = getParents(self);
    if (!parent.classList.contains("active")) {
      // For Parent Siblings
      for (var j = 0; j < parentSiblings.length; j++) {
        parentSiblings[j].classList.remove("active");
        if (typeof parentSiblings[j].childNodes[1] !== "undefined") {
          parentSiblings[j].childNodes[1].style.height = 0;
        }
      }
      if (parentMenu !== null) {
        if (!parentMenu.classList.contains("sub-opened")) {
          parentMenu.classList.add("sub-opened");

          for (var l = 0; l < parentMenus.length; l++) {
            if (typeof parentMenus !== "undefined") {
              if (parentMenus[l].classList.contains("nk-menu-wrap")) {
                parentMenus[l].style.height = subMenuHeight + parentMenus[l].clientHeight + "px";
              }
            }
          }
        }
      }
      // For Current Element
      parent.classList.add("active");
      subMenu.style.height = subMenuHeight + "px";
    } else {
      parent.classList.remove("active");
      if (parentMenu !== null) {
        parentMenu.classList.remove("sub-opened");
        for (var k = 0; k < parentMenus.length; k++) {
          if (typeof parentMenus !== "undefined") {
            if (parentMenus[k].classList.contains("nk-menu-wrap")) {
              parentMenus[k].style.height = parentMenus[k].clientHeight - subMenuHeight + "px";
            }
          }
        }
      }
      subMenu.style.height = 0;
    }
  };

  const menuItemClass = classNames({
    "nk-menu-item": true,
    "has-sub": sub,
    "active current-page": currentUrl === process.env.PUBLIC_URL + link,
  });
  return (
    <li className={menuItemClass} onClick={(e) => toggleActionSidebar(e)}>
      {newTab ? (
        <Link
          to={`${process.env.PUBLIC_URL + link}`}
          target="_blank"
          rel="noopener noreferrer"
          className="nk-menu-link"
        >
          {icon ? (
            <span className="nk-menu-icon">
              <Icon name={icon} />
            </span>
          ) : null}
          <span className="nk-menu-text">{text}</span>
        </Link>
      ) : (
        <NavLink
          to={`${process.env.PUBLIC_URL + link}`}
          className={`nk-menu-link${sub ? " nk-menu-toggle" : ""}`}
          onClick={sub ? menuToggle : null}
        >
          {icon ? (
            <span className="nk-menu-icon">
              <Icon name={icon} />
            </span>
          ) : null}
          <span className="nk-menu-text">{text}</span>
          {badge && <span className={`nk-menu-badge ${badgeClass || ""}`}>{badge}</span>}
        </NavLink>
      )}
      {sub ? (
        <div className="nk-menu-wrap">
          <MenuSub sub={sub} sidebarToggle={sidebarToggle} mobileView={mobileView} />
        </div>
      ) : null}
    </li>
  );
};

const PanelItem = ({ icon, link, text, subPanel, index, data, setMenuData, sidebarToggle, mobileView, ...props }) => {
  const menuItemClass = classNames({
    "nk-menu-item": true,
  });

  if (data === menu) {
    return (
      <li className={menuItemClass}>
        <Link
          to={`${process.env.PUBLIC_URL}${link}`}
          className="nk-menu-link"
          onClick={() => setMenuData([menu[index]])}
        >
          {icon ? (
            <span className="nk-menu-icon">
              <Icon name={icon} />
            </span>
          ) : null}
          <span className="nk-menu-text">{text}</span>
        </Link>
      </li>
    );
  } else {
    return (
      <React.Fragment>
        {subPanel.map((item) => (
          <MenuItem
            key={item.text}
            link={item.link}
            icon={item.icon}
            text={item.text}
            badge={item.badge}
            badgeClass={item.badgeClass}
            sub={item.subMenu}
            sidebarToggle={sidebarToggle}
            mobileView={mobileView}
          />
        ))}
      </React.Fragment>
    );
  }
};

const MenuSub = ({ icon, link, text, sub, sidebarToggle, mobileView, ...props }) => {
  return (
    <ul className="nk-menu-sub" style={props.style}>
      {sub.map((item) => (
        <MenuItem
          link={item.link}
          icon={item.icon}
          text={item.text}
          sub={item.subMenu}
          badge={item.badge}
          badgeClass={item.badgeClass}
          key={item.text}
          newTab={item.newTab}
          sidebarToggle={sidebarToggle}
          mobileView={mobileView}
        />
      ))}
    </ul>
  );
};

const checkMenuUrl = (data) => {
  for (const node of data.subMenu) {
    if (process.env.PUBLIC_URL + node.link === window.location.pathname) {
      return node;
    } else {
      const newNode = node.subMenu ? checkMenuUrl(node) : undefined;
      if (newNode) return newNode;
    }
  }
};

/** Filtre récursivement les sous-menus (y compris imbriqués, ex. Actions). */
const filterSubMenuByPermissions = (subMenu) => {
  if (!subMenu || subMenu.length === 0) return [];
  const filtered = [];
  for (const subItem of subMenu) {
    if (subItem.subMenu && subItem.subMenu.length > 0) {
      const nested = filterSubMenuByPermissions(subItem.subMenu);
      if (nested.length === 0) continue;
      const parentOk =
        !subItem.permissions || subItem.permissions.length === 0 || hasAnyPermission(subItem.permissions);
      if (parentOk) {
        filtered.push({ ...subItem, subMenu: nested });
      }
    } else {
      if (subItem.permissions && subItem.permissions.length > 0) {
        if (!hasAnyPermission(subItem.permissions)) continue;
      }
      filtered.push(subItem);
    }
  }
  return filtered;
};

// Fonction pour filtrer le menu selon les permissions
const filterMenuByPermissions = (menuItems) => {
  // Si superadmin, retourner tout le menu sans filtre
  if (isSuperAdmin()) {
    return menuItems;
  }

  const filteredItems = menuItems
    .map((item) => {
      // Conserver temporairement les headings; ils seront nettoyés ensuite s'ils sont orphelins.
      if (item.heading) return item;

      // Si l'item a des permissions, vérifier qu'au moins une est présente
      if (item.permissions && item.permissions.length > 0) {
        if (!hasAnyPermission(item.permissions)) {
          return null;
        }
      }

      // Si l'item a un sous-menu, filtrer aussi les sous-éléments (récursif)
      if (item.subMenu && item.subMenu.length > 0) {
        const filteredSubMenu = filterSubMenuByPermissions(item.subMenu);
        if (filteredSubMenu.length === 0) {
          return null;
        }
        return { ...item, subMenu: filteredSubMenu };
      }

      return item;
    })
    .filter(Boolean);

  // Nettoyage final:
  // - supprime les headings orphelins
  // - supprime les headings consécutifs (ne garde que le plus proche du bloc visible)
  const cleaned = [];
  let pendingHeading = null;

  for (const item of filteredItems) {
    if (item.heading) {
      pendingHeading = item;
      continue;
    }

    if (pendingHeading) {
      cleaned.push(pendingHeading);
      pendingHeading = null;
    }
    cleaned.push(item);
  }

  return cleaned;
};

const injectRiskScoreBadge = (menuItems, highRiskCount) => {
  const clonedItems = JSON.parse(JSON.stringify(menuItems));
  const badgeValue = highRiskCount > 99 ? "99+" : String(highRiskCount);

  return clonedItems.map((item) => {
    if (!item.subMenu || !Array.isArray(item.subMenu)) {
      return item;
    }

    return {
      ...item,
      subMenu: item.subMenu.map((subItem) => {
        if (subItem.link !== "/analytics/risk-score-7d") {
          return subItem;
        }

        if (highRiskCount > 0) {
          return {
            ...subItem,
            badge: badgeValue,
            badgeClass: "bg-danger text-white",
          };
        }

        return {
          ...subItem,
          badge: undefined,
          badgeClass: undefined,
        };
      }),
    };
  });
};

const Menu = ({ sidebarToggle, mobileView }) => {
  const [highRiskCount, setHighRiskCount] = useState(0);
  const [data, setMenuData] = useState(() => filterMenuByPermissions(injectRiskScoreBadge(menu, 0)));

  useEffect(() => {
    let cancelled = false;

    const loadRiskBadge = async () => {
      try {
        const response = await api.getRiskScore7d({ group_by: "site", limit: 1 });
        if (cancelled) return;
        const count = Number(response?.summary?.high_risk || 0);
        setHighRiskCount(Number.isFinite(count) ? count : 0);
      } catch (error) {
        if (!cancelled) {
          setHighRiskCount(0);
        }
      }
    };

    loadRiskBadge();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let filteredMenu = filterMenuByPermissions(injectRiskScoreBadge(menu, highRiskCount));
    
    filteredMenu.forEach((item) => {
      if (item.panel) {
        let found = item.subPanel.find((sPanel) => process.env.PUBLIC_URL + sPanel.link === window.location.pathname);
        if (found) {
          setMenuData([filteredMenu[filteredMenu.length - 1]]);
        } else {
          setMenuData(filteredMenu);
          item.subPanel.forEach((p) => {
            found = checkMenuUrl(p);
            if (found) {
              setMenuData([filteredMenu[filteredMenu.length - 1]]);
            }
          });
        }
      }
    });
    
    // Si pas de panel, utiliser le menu filtré
    if (!filteredMenu.some(item => item.panel)) {
      setMenuData(filteredMenu);
    }
  }, [window.location.pathname, highRiskCount]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ul className="nk-menu" id="main-menu">
      {data.map((item, index) =>
        item.heading ? (
          <MenuHeading heading={item.heading} key={item.heading} />
        ) : item.panel ? (
          <PanelItem
            key={item.text}
            link={item.link}
            icon={item.icon}
            text={item.text}
            index={index}
            panel={item.panel}
            subPanel={item.subPanel}
            data={data}
            setMenuData={setMenuData}
            sidebarToggle={sidebarToggle}
            mobileView={mobileView}
          />
        ) : mobileView ? (
          <MenuItem
            key={item.text}
            link={item.link}
            icon={item.icon}
            text={item.text}
            sub={item.subMenu}
            child={item.child}
            badge={item.badge}
            badgeClass={item.badgeClass}
            sidebarToggle={sidebarToggle}
            mobileView={mobileView}
          />
        ) : (
          item.text !== "Applications" && (
            <MenuItem
              key={item.text}
              link={item.link}
              icon={item.icon}
              text={item.text}
              sub={item.subMenu}
              child={item.child}
              badge={item.badge}
              badgeClass={item.badgeClass}
              sidebarToggle={sidebarToggle}
              mobileView={mobileView}
            />
          )
        )
      )}
    </ul>
  );
};

export default Menu;
